import React from 'react';
import '../styles/Condition.css';
import { YearBuilt } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';
import { HelpCircleIcon } from 'hugeicons-react';

function Condition(props) {
    const label = props.label;
    const iconBG = props.iconBG;
    const darkMode = props.darkMode;
    return (
        <div className={"condition-container " + (darkMode === true ? "bg-colour-dark-5-transparent" : "bg-colour-white")}>
            <div className={"condition-icon-container " + (iconBG)}>
                {
                    label === "Unclear" ?
                    <HelpCircleIcon size={14} color={darkMode === true ? colour.gray06 : colour.gray05} />
                    :
                    <YearBuilt
                        fill={darkMode === true ? colour.gray06 : colour.gray00}
                        className="condition-icon"
                    />
                }
            </div>
            <span className={"body-semibold " + (darkMode === true ? "colour-white" : "colour-primary")}>
                {label}
            </span>
        </div>
    )
};

export default Condition;